import { render, staticRenderFns } from "./VideoGridItem.vue?vue&type=template&id=6499efc0&"
import script from "./VideoGridItem.vue?vue&type=script&lang=js&"
export * from "./VideoGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports